import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Info = ({
  size,
  type,
  theme,
  className,
  dataTestId = "info-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.0013 7.33313C8.36949 7.33313 8.66797 7.63161 8.66797 7.9998V10.9998C8.66797 11.368 8.36949 11.6665 8.0013 11.6665C7.63311 11.6665 7.33463 11.368 7.33463 10.9998V7.9998C7.33463 7.63161 7.63311 7.33313 8.0013 7.33313Z" />
    <path d="M8.0013 5.9998C8.55359 5.9998 9.0013 5.55208 9.0013 4.9998C9.0013 4.44751 8.55359 3.9998 8.0013 3.9998C7.44902 3.9998 7.0013 4.44751 7.0013 4.9998C7.0013 5.55208 7.44902 5.9998 8.0013 5.9998Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.300781 8.00004C0.300781 3.76426 3.74217 0.33313 7.98405 0.33313C12.2259 0.33313 15.6673 3.76426 15.6673 8.00004C15.6673 12.2358 12.2259 15.6669 7.98405 15.6669C3.74217 15.6669 0.300781 12.2358 0.300781 8.00004ZM7.98405 1.66646C4.47561 1.66646 1.63411 4.50357 1.63411 8.00004C1.63411 11.4965 4.47561 14.3336 7.98405 14.3336C11.4925 14.3336 14.334 11.4965 14.334 8.00004C14.334 4.50357 11.4925 1.66646 7.98405 1.66646Z"
    />
  </SVGIcon>
);
